import styled from 'styled-components'
import { get } from '@ally/metronome-ui'
import { DumbDrawer } from '.'

const SpendBucketsDrawerStyle = styled(DumbDrawer)`
  background-color: ${get.colors('white')};
  border: 1px solid ${get.colors('slate-2')};
  border-bottom: none;

  .drawer-controls {
    position: relative;
    padding: ${get.space('xs')} ${get.space('sm')};
    button > span > span {
      color: ${get.colors('bluesuedeshoes')};
    }
    display: flex;
    justify-content: space-between;

    svg {
      margin-left: ${get.space('xxs')};
      margin-right: ${get.space('xxs')};
      position: relative;
      top: -2px;
      ${get.media.up('lg')} {
        top: -1px;
      }
    }
    ${get.media.up('lg')} {
      button[aria-expanded='true'] {
        > span {
          &::before {
            top: 22px;
            position: absolute;
            content: ' ';
            border-bottom: 16px solid ${get.colors('slate-2')};
            border-left: 16px solid transparent;
            border-right: 16px solid transparent;
          }
          &::after {
            top: 27.5px;
            position: absolute;
            content: ' ';
            border-bottom: 12px solid ${get.colors('white')};
            border-left: 12px solid transparent;
            border-right: 12px solid transparent;
            z-index: 1;
          }
        }
      }

    }
  }
  }

  .drawer-content {
    border-top: 4px solid ${get.colors('slate-2')};
    border-bottom: 5px solid ${get.colors('slate-2')};
    margin-bottom: ${get.space('sm')};
    padding: ${get.space('sm')};
    position: relative;

    button[aria-label="Close"] {
      position: absolute;
      top: ${get.space('sm')};
      right: ${get.space('sm')};
    }
  }
`

export { SpendBucketsDrawerStyle }
